import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import homeicon from '../../assests/karaicon.svg';
import collectionproductSectionBg from '../../assests/collectionproductSectionBg.png';
import Footer from '../Footer';

const CollectionProducts = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
  setIsConceptOpen(!isConceptOpen);
};

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Navbar - Always Visible */}
      <nav className="collection-products-navbar">
        <div className="collection-products-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="collection-products-logo-icon" />
          </Link>
        </div>
        <div className="collection-products-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="collection-products-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="collection-products-nav-overlay">
          <div className="collection-products-nav-close" onClick={toggleMenu}>
            <IoClose className="collection-products-close-icon" />
          </div>
          <nav className="collection-products-navigation">
            <ul className="collection-products-nav-list">
              <li><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li className="active"><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li> */}

               {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: Hero */}
      <section className="collection-products-section-1">
        {/* Background Image */}
        <div className="collection-products-section-1-background">
          <img src={collectionproductSectionBg} alt="Collections Background" className="collection-products-section-1-bg-image" />
        </div>

        {/* Overlay */}
        <div className="collection-products-section-1-overlay"></div>

        {/* Bottom Content */}
        <div className="collection-products-section-1-content">
          <p className="collection-products-section-1-label">Collections & Products</p>
          <h1 className="collection-products-section-1-title">
            Design, Crafted. <br/>Stories, Told.
          </h1>
          <p className="collection-products-section-1-description">
            Explore exclusive collections and handcrafted pieces that blend tradition, sustainability, and one-of-one design sensibilities. Each product is a story waiting to be lived.
          </p>
        </div>
      </section>

      {/* SECTION 2: Gallery Section */}
        <section className="collection-products-section-3">
        <div className="collection-products-section-3-gallery">
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection1.jpg')} 
                alt="Crafted Furniture 1" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">Flipside Table</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection2.jpg')} 
                alt="Crafted Furniture 2" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">lacy chair</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection1.jpg')} 
                alt="Crafted Furniture 3" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title margin-collection">linea console</p> */}
            </div>
        </div>
        </section>

        {/* SECTION 2: padding-top 0 */}
        <section className="collection-products-section-nopadding">
        <div className="collection-products-section-3-gallery">
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection4.jpg')} 
                alt="Crafted Furniture 1" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">Muave sofa</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection5.jpg')} 
                alt="Crafted Furniture 2" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">SAhara chest</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection6.jpg')} 
                alt="Crafted Furniture 3" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title margin-collection">Spindle chair</p> */}
            </div>
        </div>
        </section>

        {/* SECTION 3: padding-bottom 40 */}
        <section className="collection-products-section-paddingbottom">
        <div className="collection-products-section-3-gallery">
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection7.jpg')} 
                alt="Crafted Furniture 1" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">The rise stool</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection3.jpg')} 
                alt="Crafted Furniture 2" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">LAMP</p> */}
            </div>
            <div className="collection-products-section-3-image-wrapper">
            <img 
                src={require('../../assests/karacollection9.jpg')} 
                alt="Crafted Furniture 3" 
                className="collection-products-section-3-image" 
            />
            {/* <p className="collection-products-section-3-image-title">Blend Sofa</p> */}
            </div>
        </div>
        </section>

        {/* PAGINATION SECTION */}
        {/* <section className="collection-products-pagination-section">
        <div className="collection-products-pagination">
           
            <div className="collection-products-pagination-item active">
            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none" className="collection-products-pagination-circle">
                <circle cx="18.5" cy="18.5" r="18.5" fill="#D9D9D9"/>
            </svg>
            <span className="collection-products-pagination-number">1</span>
            </div>

            
            <div className="collection-products-pagination-item">
            <span className="collection-products-pagination-number">2</span>
            </div>

           
            <div className="collection-products-pagination-item">
            <span className="collection-products-pagination-number">3</span>
            </div>

           
            <div className="collection-products-pagination-item">
            <span className="collection-products-pagination-number">4</span>
            </div>

           
            <div className="collection-products-pagination-item">
            <span className="collection-products-pagination-number">5</span>
            </div>

            
            <div className="collection-products-pagination-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M9 18L15 12L9 6" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            </div>
        </div>
        </section> */}
        
        {/* COLLECTION PRODUCTS SECTION 4: Let's Create Luxury Together */}
        <section className='collection-products-section-4-cta'> 
        <h1 className='collection-products-section-4-cta-heading'>Let's Create Luxury Together</h1>
        <p className='collection-products-section-4-cta-para'>Interested in something uniquely yours? Our team will work closely with you from concept to final craftsmanship.</p>
        <Link to="/contact">
            <button className='collection-products-section-4-cta-button'>Own a Legacy Piece Today</button>
        </Link>
        </section>

        <Footer/>
        
    </>
  );
};

export default CollectionProducts;